import createStyleNode from './createStyleNode';

export default function getStyleNode(styleNodes, baseNode, type) {
  var media = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

  var key = type + media;

  if (!styleNodes[key]) {
    styleNodes[key] = createStyleNode(type, media, baseNode);
  }

  return styleNodes[key];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela/node_modules/fela-utils/es/getStyleNode.js
// module id = 693
// module chunks = 0